module.exports.addBlankToUrls = (html) => {
  return html.split('<a').join('<a target="_blank" rel="noopener noreferrer"');
};
